import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { storeRequester } from "App";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import dummyImg from "resources/img/dummy.png";

function DeskTopNotice(props) {
  const { t } = useTranslation();
  const { type } = props;
  const [articles, setArticles] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    storeRequester.getArticle(
      { expand: "board", border_name: "banner" },
      ({ articles }) => setArticles(articles)
    );
  }, []);

  const ArticleCard = (props) => {
    const { data, index, img } = props;
    const onBannerClick = () => {
      navigate("/article/notice/detail", {
        state: {
          data: data,
          img: img,
          articleList: articles, // 전체 목록 전달
          currentIndex: index, // 현재 인덱스 전달
        },
      });
    };
    const endDate = data.end_date ? new Date(data.end_date) : null;
    const today = new Date();
    let status = "공지";
    let daysRemaining = null;

    if (endDate === null) {
      status = "공지";
    } else if (endDate < today) {
      status = "종료";
    } else {
      const timeDiff = endDate - today; // 밀리초 차이
      daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)); // 일 단위로 변환
      status = `${daysRemaining}일남음`;
      // 오늘 날짜와 종료 날짜의 차이를 계산
    }

    return (
      <div
        onClick={onBannerClick}
        style={{
          height: "300px",
          cursor: "pointer",
          flex: "1 1 40%",
          maxWidth: "45%",
          position: "relative",
          borderRadius: "10px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            height: "40px",
            backgroundColor: "rgba(77, 79, 86, 0.7)",
            position: "absolute",
            top: 0,
          }}
        >
          <HorizontalFlex width={"95%"} gap={15}>
            <FlexChild
              justifyContent={"flex-start"}
              gap={10}
              padding={"0 10px"}
            >
              <div
                style={{
                  width: "80px",
                  backgroundColor:
                    status === `${daysRemaining}일남음`
                      ? "var(--main-color)"
                      : status === "종료"
                      ? "#aaa"
                      : "white",
                  padding: "3px 10px",
                  borderRadius: "5px",
                }}
              >
                <Center>
                  <P
                    weight={700}
                    color={status === `${daysRemaining}일남음` && "white"}
                  >
                    {status}
                  </P>
                </Center>
              </div>
              <P color={"white"} size={18}>
                {data.title}
              </P>
            </FlexChild>
            <FlexChild justifyContent={"flex-end"}>
              <FontAwesomeIcon icon={faAngleRight} color={"white"} />
            </FlexChild>
          </HorizontalFlex>
        </div>
        {/* {status === "진행중" && daysRemaining !== null && (
                    <div style={{
                        position: "absolute",
                        top: "50px",
                        left: "10px",
                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                        color: "white",
                        padding: "5px 10px",
                        borderRadius: "5px"
                    }}>
                        <P size={14}>남은 일수: {daysRemaining}일</P>
                    </div>
                )} */}
        <img src={img ? img : dummyImg} width={"100%"} height={"100%"} />
      </div>
    );
  };

  return (
    <VerticalFlex flexStart gap={20}>
      <FlexChild>
        <P weight={700} size={30}>
          {t(type)}
        </P>
      </FlexChild>
      <FlexChild>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
          {articles &&
            articles.map((row, index) => {
              return (
                <ArticleCard
                  data={row}
                  index={index}
                  img={row.metadata.banner}
                />
              );
            })}
        </div>
      </FlexChild>
    </VerticalFlex>
  );
}

export default DeskTopNotice;
